<template>
  <div class="debt-installment-warranty-filter">
    <b-row class="debt-installment-warranty-filter__row mb-5">
      <b-col>
        <b-form>
          <Autosuggest
            :model="searchStore"
            :suggestions="filteredStoreOptions"
            placeholder="cửa hàng"
            :limit="10"
            @select="onStoreSelected"
            @change="onStoreInputChange"
            :disabled="isStoreDisabled"
            class="debt-installment-warranty-filter__store-input"
            :aria-label="storeInputAriaLabel"
          />
        </b-form>
      </b-col>
      <b-col>
        <div class="debt-installment-warranty-filter__date-range">
          <b-input-group>
            <date-picker
              placeholder="Từ"
              class="form-control form-control-sm debt-installment-warranty-filter__date-input"
              :config="datePickerConfig"
              v-model="localFilters.fromDate"
              :aria-label="fromDateAriaLabel"
            />
          </b-input-group>
          <span class="debt-installment-warranty-filter__date-separator ml-1 mr-1"></span>
          <b-input-group>
            <date-picker
              placeholder="Đến"
              class="form-control form-control-sm debt-installment-warranty-filter__date-input"
              :config="datePickerConfig"
              v-model="localFilters.toDate"
              :aria-label="toDateAriaLabel"
            />
          </b-input-group>
        </div>
      </b-col>
      <b-col>
        <b-form>
          <b-form-select
            v-model="localFilters.contactId"
            :options="installmentOptions"
            size="sm"
            class="debt-installment-warranty-filter__select"
            :aria-label="installmentSelectAriaLabel"
          />
        </b-form>
      </b-col>
      <b-col>
        <b-input
          placeholder="Mã hợp đồng"
          v-model="localFilters.contractCode"
          size="sm"
          class="debt-installment-warranty-filter__input"
          :aria-label="contractCodeAriaLabel"
        />
      </b-col>
      <b-col>
        <b-input
          placeholder="Chứng từ"
          v-model="localFilters.docId"
          size="sm"
          class="debt-installment-warranty-filter__input"
          :aria-label="docIdAriaLabel"
        />
      </b-col>
    </b-row>
    <b-row class="debt-installment-warranty-filter__row mb-5">
      <b-col>
        <b-form>
          <b-input
            placeholder="Tìm chính xác SĐT KH"
            v-model="localFilters.customerMobile"
            size="sm"
            class="debt-installment-warranty-filter__input"
            :aria-label="customerMobileAriaLabel"
          />
        </b-form>
      </b-col>
      <b-col>
        <b-form>
          <b-form-select
            v-model="localFilters.isFullPaid"
            :options="paidStatusOptions"
            size="sm"
            class="debt-installment-warranty-filter__select"
            :aria-label="paidStatusAriaLabel"
          />
        </b-form>
      </b-col>
      <b-col>
        <b-button
          variant="primary"
          size="sm"
          @click="applyFilters"
          :disabled="isLoading"
          class="debt-installment-warranty-filter__apply-btn"
          :aria-label="applyButtonAriaLabel"
        >
          <b-spinner small v-if="isLoading"></b-spinner>
          <span v-else>Lọc</span>
        </b-button>
      </b-col>
      <b-col></b-col>
      <b-col></b-col>
    </b-row>
  </div>
</template>

<script>
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';

export default {
  name: 'DebtInstallmentWarrantyFilter',
  components: { Autosuggest },
  props: {
    value: { type: Object, default: () => ({}) },
    installmentOptions: { type: Array, default: () => [] },
    storeOptions: { type: Array, default: () => [] },
    isLoading: { type: Boolean, default: false },
  },
  data() {
    return {
      localFilters: {
        fromDate: null,
        toDate: null,
        storeId: null,
        contactId: null,
        contractCode: null,
        docId: null,
        customerMobile: null,
        isFullPaid: null,
      },
      searchStore: '',
      filteredStoreOptions: [],
      isStoreDisabled: false,
      datePickerConfig: {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        showClear: true,
        showClose: true,
        minDate: false,
        maxDate: false,
        locale: 'vi',
        sideBySide: true,
      },
      paidStatusOptions: [
        { value: null, text: 'Công nợ trả góp' },
        { value: 'true', text: 'Hết nợ' },
        { value: 'false', text: 'Còn nợ' },
      ],
    };
  },
  computed: {
    storeInputAriaLabel() {
      return 'Chọn cửa hàng để lọc dữ liệu';
    },
    fromDateAriaLabel() {
      return 'Chọn ngày bắt đầu để lọc';
    },
    toDateAriaLabel() {
      return 'Chọn ngày kết thúc để lọc';
    },
    installmentSelectAriaLabel() {
      return 'Chọn dịch vụ trả góp để lọc';
    },
    contractCodeAriaLabel() {
      return 'Nhập mã phiếu bảo hành để tìm kiếm';
    },
    docIdAriaLabel() {
      return 'Nhập số chứng từ để tìm kiếm';
    },
    customerMobileAriaLabel() {
      return 'Nhập số điện thoại khách hàng để tìm kiếm';
    },
    paidStatusAriaLabel() {
      return 'Chọn trạng thái thanh toán để lọc';
    },
    applyButtonAriaLabel() {
      return 'Áp dụng bộ lọc để tìm kiếm dữ liệu';
    },
  },
  watch: {
    value: {
      handler(newValue) {
        this.localFilters = { ...this.localFilters, ...newValue };
      },
      immediate: true,
      deep: true,
    },
    storeOptions: {
      handler(newOptions) {
        this.filteredStoreOptions = [...newOptions];
        this.initializeStoreSelection();
      },
      immediate: true,
    },
  },
  mounted() {
    window.addEventListener('keyup', this.onFilterKeyEnter);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.onFilterKeyEnter);
  },
  methods: {
    applyFilters() {
      this.$emit('input', { ...this.localFilters });
      this.$emit('apply-filters', { ...this.localFilters });
    },
    onFilterKeyEnter(event) {
      if (event.key === 'Enter') this.applyFilters();
    },
    onStoreSelected(option) {
      this.searchStore = option.item.name;
      this.localFilters.storeId = option.item.id;
    },
    onStoreInputChange(text) {
      this.searchStore = text || '';
      const filteredData = (this.storeOptions || [])
        .filter(
          (item) =>
            (item.name && item.name.toLowerCase().indexOf((text || '').toLowerCase()) > -1) ||
            (item.shortName && item.shortName.toLowerCase().indexOf((text || '').toLowerCase()) > -1),
        )
        .slice(0, 10);
      this.filteredStoreOptions = [...filteredData];
    },
    initializeStoreSelection() {
      if (!this.storeOptions || this.storeOptions.length === 1) {
        const store = (this.storeOptions || [])[0];
        if (store) {
          this.searchStore = store.name;
          this.localFilters.storeId = store.id;
          this.isStoreDisabled = true;
        }
      } else if (this.storeOptions && this.storeOptions.length > 1) {
        const defaultStore = this.storeOptions.find((s) => s.id === null);
        if (defaultStore) {
          this.searchStore = defaultStore.name;
          this.localFilters.storeId = defaultStore.id;
        }
        this.isStoreDisabled = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.debt-installment-warranty-filter {
  &__date-range {
    display: flex;
    align-items: center;
  }
  &__date-input,
  &__input,
  &__select {
    border: 1px solid #ced4da;
    box-shadow: none !important;
  }
  &__apply-btn {
    font-weight: 600;
    width: 70px;
  }
}
</style>
